import React from 'react';
import Table from "../../../components/table/table";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faEdit, faTrash, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import defaultConnect from '../../../components/redux/defaultConnect';
import makeRequest from '../../../lib/apiService';
import Confirmacion from '../../../components/confirmacion/confirmacion';
import './styles.css';

const defaultFilters = {
  search: '',
};

const AVATAR_COLORS = ['#395FC2', '#2D9CDB', '#6FCF97', '#F2994A', '#EB5757', '#9B51E0', '#56CCF2'];

function getAvatarColor(name) {
  return AVATAR_COLORS[(name || ' ').charCodeAt(0) % AVATAR_COLORS.length];
}

class TablaChoferes extends React.Component {
  state = {
    tabla: {
      rows: [],
      total: 0,
      activePage: 1,
      size: 10,
    },
    confirmation: {
      show: false,
      message: '',
      accept: f => f,
      acceptParams: {},
    },
    filters: defaultFilters,
  };

  componentDidMount() {
    this.getData();
  }

  getData = async (page = 1) => {
    const { tabla: { size }, filters } = this.state;
    const { setLoading, pushError } = this.props;

    try {
      setLoading(true);
      const resp = await makeRequest(
        `drivers/?limit=${size}&page=${page}`
        + `${filters.search ? `&search=${filters.search}` : ''}`,
        { method: 'GET' },
      );
      this.setState((prevState) => ({
        tabla: {
          ...prevState.tabla,
          rows: resp.rows,
          total: resp.count,
          activePage: page,
        }
      }), () => { setLoading(false); });
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  paginationHandler = (event, value) => {
    const { tabla, tabla: { activePage } } = this.state;

    switch (event) {
      case 'page': {
        let pagina = value;
        if (pagina === 'prev') {
          pagina = (activePage - 1);
        } else if (pagina === 'next') {
          pagina = (activePage + 1);
        }
        this.getData(pagina);
        break;
      }
      case 'size':
        this.setState({ tabla: { ...tabla, size: parseInt(value, 10) } }, () => {
          this.getData(activePage);
        });
        break;
      default: break;
    }
  }

  handleFilterChange = ({ target: { name, value } }) => {
    this.setState(
      prevState => ({
        tabla: { ...prevState.tabla, activePage: 1 },
        filters: { ...prevState.filters, [name]: value },
      }),
      this.getData,
    );
  }

  clearFilters = () => {
    this.setState({ filters: defaultFilters }, this.getData);
  }

  toggleConfirmation = (confirmation) => this.setState((prevState) => ({
    confirmation: {
      ...prevState.confirmation,
      ...confirmation,
      show: !prevState.confirmation.show,
    },
  }));

  deleteConfirmation = (id) => this.toggleConfirmation({
    message: 'El chofer será eliminado completamente del sistema.',
    accept: this.deleteChofer,
    acceptParams: { id },
  });

  deleteChofer = async () => {
    const { setLoading, pushError, pushSuccess } = this.props;
    const {
      tabla: { activePage },
      confirmation: { acceptParams: { id } }
    } = this.state;

    try {
      this.toggleConfirmation();
      setLoading(true);
      await makeRequest(
        `drivers/${id}`,
        { method: 'DELETE' },
      );
      setLoading(false);
      pushSuccess('Se ha realizado el cambio con exito.', 3000);
      this.getData(activePage);
    } catch (error) {
      setLoading(false);
      pushError(error.message);
    }
  }

  render() {
    const { tabla, confirmation, filters } = this.state;
    const columns = ['Chofer', 'Contacto de emergencia', 'Concesionario', 'Vehículo', 'Opciones'];

    const rows = tabla.rows.map(row => ({
      driver: { name: row.name, last_name: row.last_name, id: row.id_driver, phone: row.phone_number },
      emergency: { name: row.emergency_contact_name, phone: row.emergency_contact_phone },
      user: row.id_user,
      vehicles: row.vehicles,
      options: row.id_driver,
    }));

    const configTable = {
      columnDef: {
        driver: val => (
          <div className="chofer-cell">
            <div
              className="chofer-avatar"
              style={{ backgroundColor: getAvatarColor(val.name) }}
            >
              {(val.name || '?')[0]}{(val.last_name || '')[0]}
            </div>
            <div>
              <div className="chofer-name">{val.name} {val.last_name}</div>
              <div className="chofer-meta">#{val.id} · {val.phone || 'Sin teléfono'}</div>
            </div>
          </div>
        ),
        emergency: val => (
          val && val.name
            ? (
              <div>
                <div className="chofer-name">{val.name}</div>
                <div className="chofer-meta">{val.phone || 'Sin teléfono'}</div>
              </div>
            )
            : <span className="text-muted" style={{ fontSize: '.85em' }}>Sin registrar</span>
        ),
        vehicles: val => {
          if (!val || val.length === 0) {
            return <span className="text-muted" style={{ fontSize: '.85em' }}>Sin vehículo asignado</span>;
          }
          const visible = val.slice(0, 3);
          const remaining = val.length - visible.length;
          const allKeys = val.map(v => v.key_vehicle).join(', ');
          return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
              {visible.map(v => (
                <span key={v.id_vehicle} className="badge badge-secondary">{v.key_vehicle}</span>
              ))}
              {remaining > 0 && (
                <span className="badge badge-light" title={allKeys} style={{ cursor: 'default' }}>
                  +{remaining} más
                </span>
              )}
            </div>
          );
        },
        user: val => (
          val
            ? (
              <Link className="badge badge-primary" to={`/panel/concesionarios/concesionario/detalles/${val}`}>
                Concesionario #{val}
              </Link>
            )
            : <span className="text-muted" style={{ fontSize: '.85em' }}>Sin asignar</span>
        ),
        options: val => (
          <div className="btn-action-group">
            <Link className="btn btn-sm btn-light" to={`choferes/chofer/detalles/${val}`}>
              <FontAwesomeIcon icon={faList} style={{ marginRight: '.25rem' }} />
              Ver más
            </Link>
            <Link className="btn btn-sm btn-sl-2" to={`choferes/chofer/${val}`}>
              <FontAwesomeIcon icon={faEdit} />
            </Link>
            <button type="button" className="btn btn-sm btn-danger" onClick={() => { this.deleteConfirmation(val); }}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        ),
      },
      columnStyle: {
        options: {
          whiteSpace: 'nowrap',
        },
      },
    };

    return (
      <div className="tabla-choferes">

        <div className="row mb-3">
          <div className="col-12 col-md-5">
            <div className="input-group chofer-search-group">
              <div className="input-group-prepend">
                <span className="input-group-text chofer-search-addon">
                  <FontAwesomeIcon icon={faSearch} />
                </span>
              </div>
              <input
                type="text"
                name="search"
                className="form-control chofer-search-input"
                placeholder="Buscar por nombre o vehículo..."
                value={filters.search}
                onChange={this.handleFilterChange}
                autoComplete="off"
              />
              {filters.search && (
                <div className="input-group-append">
                  <button type="button" className="btn chofer-search-clear" onClick={this.clearFilters}>
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <Table
          columns={columns}
          data={rows}
          configTable={configTable}
          pagination={{
            total: tabla.total,
            page: tabla.activePage,
            limit: tabla.size
          }}
          paginationEvent={this.paginationHandler}
          updateTable={() => {
            this.getData(tabla.activePage);
          }}
          tableClass={"datatable-wrapper"}
        />

        {confirmation.show && <Confirmacion message={confirmation.message} accept={confirmation.accept} cancel={() => { this.toggleConfirmation(undefined); }} />}

      </div>
    );
  }
}

export default defaultConnect(TablaChoferes);
